export default __webpack_public_path__ + "static/media/Dinosaurs_09.77cd2207.png";